/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
  Vue, Component, Model, Prop, Watch,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import {
  Form, Field, Validator, ValidateError,
} from '@hb/finance-ui';
import { Popup } from 'vant';
import { Toast } from '@hb/coffee';

import IconSvg from '@/components/Icon-svg';
import { ubtPageButton } from '@/shared/utils/ubt';
import { FormInfomation } from '@/views_v2/card-list/types';
import { BindCardParamsTypes } from '@/api/bank-card/types';

const style = require('./index.module.scss');

const CardBindStore = namespace('cardBind');

@Component
export default class SmsConfirm extends Vue {
  @Model('change', {
    type: Boolean,
  })
  readonly visible!: boolean;

  @Prop(String) readonly commodityId!: string;

  @Prop(String) readonly capitalCode!: string;

  @Prop(String) readonly loanOrderId!: string;

  @Prop(String) readonly entryFrom!: FormInfomation;

  @CardBindStore.State reservePhone!: string;

  @CardBindStore.State sendSmsTimeStamp!: number;

  @CardBindStore.Action $updateState!: (data: Dictionary) => void;

  @CardBindStore.Action sendSmsOrBindCard!: (params: BindCardParamsTypes) => Promise<boolean>;

  @CardBindStore.Action submitCardBind!: (
    payload:
    {
      entryFrom: string;
      capitalCode: string;
      loanOrderId: string;
    }
  ) => Promise<boolean>;

  private countDownInterval: NodeJS.Timer | null = null;

  // 手机验证码
  private get smsCode(): string {
    return String(this.$store.state.cardBind.smsCode);
  }

  private set smsCode(value: string) {
    this.$updateState({
      smsCode: value,
    });
  }

  private get maskedPhoneNo(): string {
    return String(this.reservePhone || '')
      .replace(/\s/g, '')
      .replace(/\d{3}(\d{6})\d{4}/, '******');
  }

  // 是否处于倒计时
  public isSmsCountingDown(): boolean {
    return (
      Math.round((new Date().getTime() - this.sendSmsTimeStamp) / 1000) <= 60
    );
  }

  // 倒计时
  private getCountDownSeconds(): number {
    return (
      60
      - Math.min(
        Math.round((new Date().getTime() - this.sendSmsTimeStamp) / 1000),
        60,
      )
    );
  }

  // 获取发送短信验证码按钮文案
  private getSendButtonTextName(): string {
    const isSmsCountingDown = this.isSmsCountingDown();
    const countDownSeconds = this.getCountDownSeconds();

    if (!isSmsCountingDown || countDownSeconds === 0) {
      return '获取验证码';
    }

    return `重新获取${countDownSeconds}s`;
  }

  @Watch('visible')
  private onVisibleChange() {
    if (this.visible && this.isSmsCountingDown()) {
      Vue.nextTick(() => this.startCountDown());
    } else {
      this.clearCountDown(false);
    }
  }

  private beforeDestroy() {
    this.clearCountDown(false);
  }

  private render() {
    return (
      <Popup
        v-model={this.visible}
        closeOnClickOverlay={false}
        lockScroll={true}
      >
        {this.renderSmsContent()}
        {this.renderCloseIcon()}
      </Popup>
    );
  }

  private smsCodeFormatter(val: string) {
    return val.replace(/\D/g, '');
  }

  // 发送短信验证码
  private renderSmsContent() {
    const countDownSeconds = this.getCountDownSeconds();
    const isSmsCountingDown = this.isSmsCountingDown();
    const sendButtonTextName = this.getSendButtonTextName();
    const isButtonCountingDown = isSmsCountingDown && countDownSeconds !== 0;

    return (
      <Form
        noBorder
        noErrMsg
        inputHeight={41}
        onSubmit={this.onConfirm}
        class={style.dialogContent}
        labelContentClass={style.smsLabelContent}
      >
        <div class={style.headerTitle}>绑卡确认</div>
        <Field
          readonly
          label="手机号"
          labelWidth={71}
          name="reservePhone"
          value={this.maskedPhoneNo}
        />
        <Field
          name="smsCode"
          label="验证码"
          type="tel"
          labelWidth={60}
          maxLength={6}
          v-model={this.smsCode}
          placeholder="请输入验证码"
          inputContentClass={style.smsInputContent}
          formatter={this.smsCodeFormatter}
          rules={[
            {
              required: true,
              message: '请输入验证码',
            },
            {
              validator: Validator.isSmsCode,
              message: '请输入正确的验证码',
            },
          ]}
        >
          <div
            ref="countDownRef"
            slot="input-right"
            class={[
              style.sendButton,
              isButtonCountingDown && style.countingDown,
            ]}
            onClick={this.onSendSms}
          >
            {sendButtonTextName}
          </div>
        </Field>

        <button native-type="submit" class={style.confirmButton}>
          提交
        </button>
      </Form>
    );
  }

  // 关闭Icon
  private renderCloseIcon() {
    return (
      <span class={style.closeSmsDialog}>
        <IconSvg iconClass="cross" onClick={this.hideSmsDialog} />
      </span>
    );
  }

  // 开始倒计时
  private startCountDown() {
    const countDownRef = this.$refs.countDownRef as HTMLDivElement;

    if (countDownRef && !this.countDownInterval) {
      countDownRef.innerText = this.getSendButtonTextName();

      this.countDownInterval = setInterval(() => {
        if (this.getCountDownSeconds() <= 0) {
          this.clearCountDown();
        }

        countDownRef.innerText = this.getSendButtonTextName();
      }, 1000);
    }
  }

  // 重置倒计时
  private clearCountDown(forceUpdate = true) {
    if (this.countDownInterval) {
      clearInterval(this.countDownInterval);
      this.countDownInterval = null;
    }

    Vue.nextTick(() => {
      if (forceUpdate) {
        this.$forceUpdate();
      }
    });
  }

  private hideSmsDialog() {
    this.$emit('change', false);

    ubtPageButton(this, 'CloseSmsDialog', 'entryFrom', this.entryFrom);
  }

  private onSendSms() {
    if (!this.isSmsCountingDown()) {
      const params = {
        commodityId: this.commodityId,
        entryFrom: this.entryFrom,
        capitalCode: this.capitalCode,
        loanOrderId: this.loanOrderId,
      };
      this.sendSmsOrBindCard(params).then((succ) => {
        // 发送失败重置倒计时
        if (!succ) {
          this.clearCountDown();
        }
      });

      this.startCountDown();

      ubtPageButton(this, 'ResendSms', 'entryFrom', this.entryFrom);
    }
  }

  private async onConfirm(errors: ValidateError[]) {
    if (errors.length > 0) {
      Toast.fail(errors[0].message);
      return;
    }

    this.$ubtPageButton(
      'SubmitCardBind',
      'commodityId',
      this.commodityId,
      'entryFrom',
      this.entryFrom === FormInfomation.Product ? '提现' : '还款',
    );

    // 提交订单
    const bankCardId = await this.submitCardBind({
      entryFrom: this.entryFrom,
      capitalCode: this.capitalCode,
      loanOrderId: this.loanOrderId,
    });

    if (bankCardId) {
      this.$emit('bindSucc', bankCardId);
    }
  }
}
